var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99713 25.5C15.5223 25.5 20.0031 21.1581 20 15.8012C20 13.8196 19.3715 11.8865 18.2052 10.2625L16.1539 11.6502C17.9769 14.1771 17.9488 17.5464 16.0883 20.0461C15.3972 19.1129 14.4873 18.3524 13.4367 17.8252C14.9313 15.983 14.6061 13.3166 12.705 11.8683C10.8039 10.42 8.05222 10.7351 6.55757 12.5773C5.30682 14.1165 5.30682 16.286 6.55757 17.8252C5.50382 18.3494 4.5939 19.1129 3.90286 20.0461C2.04549 17.5464 2.02048 14.1802 3.84345 11.6562L1.79222 10.2685C-1.3628 14.6649 -0.243378 20.7066 4.29372 23.7638C5.96659 24.891 7.95841 25.497 9.99713 25.5ZM8.12101 15.1982C8.12101 14.1953 8.96214 13.3803 9.99713 13.3803C11.0321 13.3803 11.8733 14.1953 11.8733 15.1982C11.8733 16.2011 11.0321 17.0162 9.99713 17.0162C8.96214 17.0162 8.12101 16.2011 8.12101 15.1982ZM9.99713 19.4401C11.7451 19.4401 13.3679 20.3279 14.2747 21.7762C11.7044 23.5124 8.28986 23.5124 5.71957 21.7762C6.62324 20.3218 8.24608 19.4341 9.99713 19.4401ZM14.8 10.4776H5.19425L3.0586 3.55115L7.28926 5.31457L9.99713 0.5L12.7081 5.31457L16.9388 3.55115L14.8031 10.4776H14.8ZM6.59197 8.65962H13.4023L13.987 6.75985L11.8764 7.64156L9.99401 4.29954L8.11163 7.64156L6.00099 6.75985L6.58571 8.65962H6.59197Z",
    fill: "#FFBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6adf1156674de4bbf5d0f4ef0368f0d4.svg";
export { ForwardRef as ReactComponent };